// Maps memberId -> their Family record, for members explicitly attached to a
// real family (as head or as an approved member).
export const buildMemberFamilyMap = (families) => {
  const map = {};
  (families || []).forEach((fam) => {
    if (fam.head?.id) map[String(fam.head.id)] = fam;
    (fam.members || []).forEach((m) => {
      if (m.status === 'approved' && m.member?.id) map[String(m.member.id)] = fam;
    });
  });
  return map;
};

// An offering's userId points at a DerasarPerson (the donor, who may be a
// dependent with no login of their own). The account holder who owns that
// person — and who the family report should group/label by — is the
// offering's creator (always set to the person's createdByMemberId).
export const offeringOwner = (o) => ({
  id:   o.creator?.id   ?? o.userId?.id   ?? o.userId,
  name: o.creator?.name ?? o.member?.name ?? o.userId?.name ?? '—',
});

// Resolves the family-report group an offering belongs to, by its account
// holder (not the donor/person on the offering): their real family, or a
// single-member virtual family named "<ownerName> Family" when the account
// holder isn't attached to any family record.
export const resolveFamilyGroup = (ownerId, ownerName, familyMap) => {
  const fam = familyMap[String(ownerId)];
  if (fam) return { key: String(fam.id), label: fam.name };
  return { key: `member-${ownerId}`, label: `${ownerName} Family` };
};
